import '../css/Prescription.css';
import Review from './review';
function PrescriptionFulfillments() {
    return (
        <div className="prescription-page">
            <div className="prescription-banner">
                <img
                    src={'/img_7.png'}
                    alt="Prescription Banner"
                    className="prescription-banner-img"
                />
                <div className="prescription-banner-overlay"></div>
                <div className="prescription-banner-content">
                    <h1>Prescription Fulfillment</h1>
                </div>
            </div>

            <header className="prescription-header">
                <h2>Fast, Accurate, and Handled with the Care You Deserve</h2>
                <p>
                    At Quality Pharmacy, our dedication to great service is powered by BestRx, the advanced pharmacy management system, designed with precision and patient care at its core.
                </p>
            </header>

            <div className="prescription-cards">
                <div className="prescription-card">
                    <div className="prescription-icon">⚡</div>
                    <h3>Fast</h3>
                    <ul>
                        <li>
                            <strong>Streamlined Workflows & NightTech Automation:</strong> Auto Process and NightTech features automate refill verification, claims submission, and label printing around the clock—so your prescriptions are always ready, even before the day begins.
                        </li>
                        <li>
                            <strong>Prioritized Handling with Promise Time & Manage Intake Queue:</strong> Set delivery or pickup times with Promise Time, and smoothly handle incoming prescription orders via the intuitive Intake Queue, keeping everything moving swiftly without sacrificing control.
                        </li>
                    </ul>
                </div>
                <div className="prescription-card">
                    <div className="prescription-icon">🎯</div>
                    <h3>Accurate</h3>
                    <ul>
                        <li>
                            <strong>Custom Workflows & Error Minimization:</strong> Workflows, queues, and administrative triggers adapt seamlessly to your pharmacy's unique needs, reducing manual steps and minimizing errors throughout fulfillment.
                        </li>
                        <li>
                            <strong>Claims Optimization & Real-Time Benefit Checks:</strong> Streamlined billing via automatic claims editing, real-time cost checks, and charge management—ensuring medication costs and reimbursements are handled accurately and efficiently.
                        </li>
                        <li>
                            <strong>Messaging Alerts & Two-Way Communication:</strong> Keep patients informed and engaged with text/email reminders, updates, and confirmations—all with the option for real-time replies.
                        </li>
                    </ul>
                </div>
                <div className="prescription-card">
                    <div className="prescription-icon">💖</div>
                    <h3>Handled with the Care You Deserve</h3>
                    <ul>
                        <li>
                            <strong>Personalized MedSync & On-Time Pickups:</strong> Multiple prescriptions for the same patient can be coordinated to be ready at once—less hassle and more thoughtful service.
                        </li>
                        <li>
                            <strong>Transparent Delivery & Mobile Experience:</strong> Delivery integrations—from FedEx and UPS to ScriptDrop—complete with tracking, e-signatures, and updates via mobile.
                        </li>
                        <li>
                            <strong>Remote Access & Loyalty Engagement:</strong> Online payment, automatic refill requests, and a loyalty program—all accessible through the pharmacy’s mobile app.
                        </li>
                    </ul>
                </div>
            </div>

            <div className="prescription-benefits-card">
                <h4>What This Means for You</h4>
                <ul>
                    <li><strong>Quick & Reliable Service:</strong> Automated systems and smart workflows mean faster turnaround without cutting corners.</li>
                    <li><strong>Fewer Mistakes:</strong> Automatic claim checks and custom workflows keep fulfillment accurate—every time.</li>
                    <li><strong>Thoughtful Convenience:</strong> Prescription pick-ups or delivery aligned to your schedule, with tools designed for care and clarity.</li>
                </ul>
            </div>
             <Review/>
        </div>
    );
}

export default PrescriptionFulfillments;